var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:([_vm.elementStyles, _vm.basicContentStyles])},[_c('div',{staticClass:"video-overlay overlay-fullsize"},[_c('div',{staticClass:"wrap text-center"},[_c('i',{staticClass:"fa-regular fa-play text-white video overlay",style:({'fontSize': Math.max(_vm.min_width_height/4, 22) + 'px'})})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }